// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacySharedWebAddressModel {
    static getAttributeTypeMap() {
        return PharmacySharedWebAddressModel.attributeTypeMap;
    }
}
PharmacySharedWebAddressModel.discriminator = undefined;
PharmacySharedWebAddressModel.additionalProperties = false;
PharmacySharedWebAddressModel.attributeTypeMap = [
    {
        "name": "webAddressId",
        "baseName": "webAddressId",
        "type": "number"
    },
    {
        "name": "webAddressType",
        "baseName": "webAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacySharedWebAddressModel.js.map